<template>
  <v-container class="notigications">
    <portal to="content-before">
      <OrsInnerToolbar
        title="Minhas Notificações"
        title-icon="mdi-shield-check"
      />
    </portal>
    <v-row
      v-if="notifications == null"
      justify="center"
      class="mt-8"
    >
      <h3>
        {{status}}
      </h3>
    </v-row>
    <v-row
      v-if="title!='Desvio de hábito'"
    >
      <v-col
        v-for="(notification, alarmIdx) in notifications"
        :key="alarmIdx"
        xs="12"
        sm="6"
        md="4"
        class="col-sm-6 col-md-6 col"
      >
        <OrsCard
          :title="notification.obj.tipoDeRat"
          :image="'https://orsegupsid.s3-sa-east-1.amazonaws.com/desvio.jpg'"
        >
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-map-marker
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-capitalize">
                  {{ notification.obj.informativo }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-account
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ notification.obj.local }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-if="notification.obj.dataAtendimento !=''"
                >
                  <b> Data Atendimento: </b>{{ notification.
                    obj.dataAtendimento }} às {{ notification.
                    obj.horaAtendimento }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-if="notification.obj.evento !=''"
                >
                  EVENTO: {{ notification.obj.evento }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-if="notification.obj.fotoLocalLnk != ''
                    && notification.obj.fotoLocalLnk != null"
                >
                  <center>
                    Foto do Local: <br>
                    <br>
                    <img
                      data-v-22ba47ca=""
                      :src="notification.obj.fotoLocalLnk"
                      class="odash-dg-img"
                      style="width:200px;"
                    >
                  </center>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <center>
                    <v-dialog
                      width="800"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          v-on="on"
                        >
                          Ver Detalhes
                        </v-btn>
                        <div
                          style="color: rgb(180, 186, 194) !important;
                          font-family: sans-serif, serif,
                          EmojiFont; text-align: center;"
                          data-ogsc="rgb(96, 102, 109)"
                        >
                          <span
                            v-if="notification.obj.avaliacaoNota==null"
                            style="font-size:10px;text-transform:
                            uppercase;letter-spacing:.5px;"
                          >Avalie este atendimento
                          </span>
                          <span
                            v-else
                            style="font-size:10px;text-transform:
                            uppercase;letter-spacing:.5px;"
                          >AVALIAÇÂO JÁ EFETUADA.
                          </span>
                          <br>
                          <div
                            style="unicode-bidi:bidi-override;
                            direction:rtl;width:100%;
                            float:left;"
                          >
                            <table
                              style="color: rgb(175, 175, 175) !important;
                              font-size: 35px;; font-family: Helvetica, Arial,
                              sans-serif; width: 275px; border-collapse: collapse;
                              margin: 10px auto;"
                              data-ogsc="rgb(120, 120, 120)"
                            >
                              <tbody>
                                <tr
                                  v-if="notification.obj.avaliacaoNota==null"
                                  style="padding:0;"
                                >
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                        border-collapse: collapse; padding: 0px;
                                        line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=5&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="1"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=4&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="2"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=3&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="3"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    ><span style="color:#FFCC00;">★
                                    </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=2&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="4"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    ><span style="color:#FFCC00;">★
                                    </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                          border-collapse: collapse; padding: 0px;
                                          line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=1&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                </tr>
                                <tr
                                  v-else
                                >
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                        border-collapse: collapse; padding: 0px;
                                        line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                          border-collapse: collapse; padding: 0px;
                                          line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <br>
                        <br>
                        <br>
                      </template>

                      <v-card>
                        <v-card-title
                          primary-title
                          style="background-color: rgb(252, 227, 0);height: 65px;"
                        >
                          <v-list-item style="height:65px">
                            <v-list-item-content>
                              <v-list-item-title>
                                <div
                                  class="primary-text"
                                  style="height: 64px; background-color:
                                  rgb(252, 227, 0);height:65px"
                                >
                                  <center>
                                    <b>
                                      <font size="5">
                                        DETALHES SOBRE O ATENDIMENTO
                                      </font>
                                    </b>
                                    <v-btn
                                      style="margin-left: 50px;"
                                      text
                                    >
                                      X
                                    </v-btn>
                                  </center>
                                </div>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card-title>

                        <v-card-text>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                <center
                                  v-if="notification.obj.fotoAitLnk !== ''
                                    && notification.obj.fotoAitLnk !== null"
                                >
                                  <div style="color:#1e398d">
                                    AGENTE DE SEGURANÇA
                                  </div>
                                  <br>
                                  <center>
                                    <img
                                      data-v-22ba47ca=""
                                      style="width:120px;height:100px;"
                                      :src="notification.obj.fotoAitLnk"
                                      class="odash-dg-img"
                                    >
                                  </center>
                                  <center>
                                    <div style="color:#1e398d">
                                      {{ notification.obj.atendidoPor }}
                                    </div>
                                    <br>
                                  </center>
                                </center>
                                <span
                                  v-else
                                  style="font-size:10px;text-transform:
                                  uppercase;letter-spacing:.5px;"
                                >
                                  ''
                                </span>
                                <center
                                  v-if="notification.obj.fotoLocalLnk != ''
                                    && notification.obj.fotoLocalLnk != null"
                                >
                                  Foto do Local: <br>
                                  <br>
                                  <img
                                    data-v-22ba47ca=""
                                    :src="notification.obj.fotoLocalLnk"
                                    class="odash-dg-img"
                                    style="width:200px;"
                                  >
                                </center>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.resultado !=''"
                              >
                                Descrição: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.resultado }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary">
                                mdi-account
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <center>
                                <div style="color:#1e398d">
                                  {{ notification.obj.local }}
                                </div>
                              </center>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.dataAtendimento !=''"
                              >
                                Data Atendimento: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.
                                  obj.dataAtendimento }} às {{ notification.
                                  obj.horaAtendimento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.evento !=''"
                              >
                                Evento: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.evento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.resultadoDoAtendimento !=''"
                              >
                                Resultado do Atendimento: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.resultadoDoAtendimento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <b
                               v-if="notification.obj.observacao != ''"
                              >
                                Observações:
                              </b>
                              <div
                                style="color:#1e398d"
                              >
                                {{ notification.obj.observacao }}
                              </div>
                              <br>
                              <center
                                v-if="notification.obj.lnkImg.length>=1"
                              >
                              <br>
                              Fotos Tiradas no Local:<div
                                style="color:#1e398d"
                              >
                              <br>
                                <img  
                                    v-for="img in notification.obj.lnkImg"
                                    :key="img"
                                    data-v-22ba47ca=""
                                    :src="img.lnkImg"
                                    class="odash-dg-img"
                                    style="width:200px;margin-right:3px"
                                  >
                                  
                              </div>
                              </center>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </center>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </OrsCard>
      </v-col>
    </v-row>
    <v-row
      v-else-if="title!='Atendimento Tático'"
    >
      <v-col
        v-for="(notification, alarmIdx) in notifications"
        :key="alarmIdx"
        xs="12"
        sm="6"
        md="4"
        class="col-sm-6 col-md-6 col"
      >
        <OrsCard
          :title="notification.obj.tipoDeRat"
          :image="'https://orsegupsid.s3-sa-east-1.amazonaws.com/motocicle.png'"
        >
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-map-marker
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-capitalize">
                  {{ notification.obj.informativo }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-account
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <center>
                    <div style="color:#1e398d">
                      {{ notification.obj.local }}
                    </div>
                  </center>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-if="notification.obj.dataAtendimento !=''"
                >
                  <b> Data Atendimento: </b>{{ notification.
                    obj.dataAtendimento }} às {{ notification.
                    obj.horaAtendimento }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-if="notification.obj.evento !=''"
                >
                  EVENTO: {{ notification.obj.evento }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <center
                    v-if="notification.obj.fotoLocalLnk != ''
                      && notification.obj.fotoLocalLnk != null"
                  >
                    Foto do Local: <br>
                    <br>
                    <img
                      data-v-22ba47ca=""
                      :src="notification.obj.fotoLocalLnk"
                      class="odash-dg-img"
                      style="width:200px;"
                    >
                  </center>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <center>
                    <v-dialog
                      width="800"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          v-on="on"
                        >
                          Ver Detalhes
                        </v-btn>
                        <div
                          style="color: rgb(180, 186, 194) !important;
                          font-family: sans-serif, serif,
                          EmojiFont; text-align: center;"
                          data-ogsc="rgb(96, 102, 109)"
                        >
                          <span
                            v-if="notification.obj.avaliacaoNota==null"
                            style="font-size:10px;text-transform:
                            uppercase;letter-spacing:.5px;"
                          >Avalie este atendimento
                          </span>
                          <span
                            v-else
                            style="font-size:10px;text-transform:
                            uppercase;letter-spacing:.5px;"
                          >AVALIAÇÂO JÁ EFETUADA.
                          </span>
                          <br>
                          <div
                            style="unicode-bidi:bidi-override;
                            direction:rtl;width:100%;
                            float:left;"
                          >
                            <table
                              style="color: rgb(175, 175, 175) !important;
                              font-size: 35px;; font-family: Helvetica, Arial,
                              sans-serif; width: 275px; border-collapse: collapse;
                              margin: 10px auto;"
                              data-ogsc="rgb(120, 120, 120)"
                            >
                              <tbody>
                                <tr
                                  v-if="notification.obj.avaliacaoNota==null"
                                  style="padding:0;"
                                >
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                        border-collapse: collapse; padding: 0px;
                                        line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=5&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="1"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=4&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="2"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=3&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="3"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    ><span style="color:#FFCC00;">★
                                    </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=2&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="4"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    ><span style="color:#FFCC00;">★
                                    </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                          border-collapse: collapse; padding: 0px;
                                          line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=1&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                </tr>
                                <tr
                                  v-else
                                >
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                        border-collapse: collapse; padding: 0px;
                                        line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                          border-collapse: collapse; padding: 0px;
                                          line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <br>
                        <br>
                        <br>
                      </template>

                      <v-card>
                        <v-card-title
                          class="headline grey lighten-2"
                          primary-title
                          style="background-color: rgb(252, 227, 0);height: 65px;"
                        >
                          <v-list-item style="height:65px">
                            <v-list-item-content>
                              <v-list-item-title>
                                <div
                                  class="primary-text"
                                  style="height: 64px; background-color:
                                  rgb(252, 227, 0);height:65px"
                                >
                                  <center>
                                    <b>
                                      <font size="5">
                                        DETALHES SOBRE O ATENDIMENTO
                                      </font>
                                    </b>
                                    <v-btn
                                      style="margin-left: 50px;"
                                      text
                                    >
                                      X
                                    </v-btn>
                                  </center>
                                </div>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card-title>

                        <v-card-text>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                <center
                                  v-if="notification.obj.fotoAitLnk !== ''
                                    && notification.obj.fotoAitLnk !== null"
                                >
                                  <div style="color:#1e398d">
                                    AGENTE DE SEGURANÇA
                                  </div>
                                  <br>
                                  <center>
                                    <img
                                      data-v-22ba47ca=""
                                      style="width:120px;height:100px;"
                                      :src="notification.obj.fotoAitLnk"
                                      class="odash-dg-img"
                                    >
                                  </center>
                                  <center>
                                    <div style="color:#1e398d">
                                      {{ notification.obj.atendidoPor }}
                                    </div>
                                    <br>
                                  </center>
                                </center>
                                <span
                                  v-else
                                  style="font-size:10px;text-transform:
                                  uppercase;letter-spacing:.5px;"
                                >
                                  ''
                                </span>
                                <center
                                  v-if="notification.obj.fotoLocalLnk != ''
                                    && notification.obj.fotoLocalLnk != null"
                                >
                                  Foto do Local: <br>
                                  <br>
                                  <img
                                    data-v-22ba47ca=""
                                    :src="notification.obj.fotoLocalLnk"
                                    class="odash-dg-img"
                                    style="width:200px;"
                                  >
                                </center>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.resultado !=''"
                              >
                                Descrição: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.resultado }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary">
                                mdi-account
                              </v-icon>
                            </v-list-item-icon>
                            <center>
                              <center>
                                <div style="color:#1e398d">
                                  {{ notification.obj.local }}
                                </div>
                              </center>
                            </center>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.dataAtendimento !=''"
                              >
                                Data Atendimento: <br><b style="color:#1e398d"><br>{{ notification.
                                  obj.dataAtendimento }} às {{ notification.
                                  obj.horaAtendimento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.evento !=''"
                              >
                                Evento: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.evento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.resultadoDoAtendimento !=''"
                              >
                                Resultado do Atendimento: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.resultadoDoAtendimento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <b
                               v-if="notification.obj.observacao != ''"
                              >
                                Observações:
                              </b>
                              <div
                                style="color:#1e398d"
                              >
                                {{ notification.obj.observacao }}
                              </div>

                              <center
                                v-if="notification.obj.lnkImg.length>=1"
                              >
                              <br>

                              Fotos Tiradas no Local:<div
                                style="color:#1e398d"
                              >
                                <img
                                    v-for="img in notification.obj.lnkImg"
                                    :key="img"
                                    data-v-22ba47ca=""
                                    :src="img.lnkImg"
                                    class="odash-dg-img"
                                    style="width:200px;"
                                  >
                              </div>
                              </center>

                            </v-list-item-content>
                          </v-list-item>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </center>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </OrsCard>
      </v-col>
    </v-row>
    <v-row
      v-else-if="title!='Ordem de Serviço'"
    >
      <v-col
        v-for="(notification, alarmIdx) in notifications"
        :key="alarmIdx"
        xs="12"
        sm="6"
        md="4"
        class="col-sm-6 col-md-6 col"
      >
        <OrsCard
          :title="notification.obj.tipoDeRat"
          :image="'https://orsegupsid.s3-sa-east-1.amazonaws.com/motocicle.png'"
        >
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-map-marker
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-capitalize">
                  {{ notification.obj.informativo }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-account
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ notification.obj.local }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-if="notification.obj.dataAtendimento !=''"
                >
                  <b> Data Atendimento: </b>{{ notification.
                    obj.dataAtendimento }} às {{ notification.
                    obj.horaAtendimento }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-if="notification.obj.evento !=''"
                >
                  EVENTO: {{ notification.obj.evento }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <center
                    v-if="notification.obj.fotoLocalLnk != ''
                      && notification.obj.fotoLocalLnk != null"
                  >
                    Foto do Local: <br>
                    <br>
                    <img
                      data-v-22ba47ca=""
                      :src="notification.obj.fotoLocalLnk"
                      class="odash-dg-img"
                      style="width:200px;"
                    >
                  </center>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <center>
                    <v-dialog
                      width="800"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          v-on="on"
                        >
                          Ver Detalhes
                        </v-btn>
                        <div
                          style="color: rgb(180, 186, 194) !important;
                          font-family: sans-serif, serif,
                          EmojiFont; text-align: center;"
                          data-ogsc="rgb(96, 102, 109)"
                        >
                          <span
                            v-if="notification.obj.avaliacaoNota==null"
                            style="font-size:10px;text-transform:
                            uppercase;letter-spacing:.5px;"
                          >Avalie este atendimento
                          </span>
                          <span
                            v-else
                            style="font-size:10px;text-transform:
                            uppercase;letter-spacing:.5px;"
                          >AVALIAÇÂO JÁ EFETUADA.
                          </span>
                          <br>
                          <div
                            style="unicode-bidi:bidi-override;
                            direction:rtl;width:100%;
                            float:left;"
                          >
                            <table
                              style="color: rgb(175, 175, 175) !important;
                              font-size: 35px;; font-family: Helvetica, Arial,
                              sans-serif; width: 275px; border-collapse: collapse;
                              margin: 10px auto;"
                              data-ogsc="rgb(120, 120, 120)"
                            >
                              <tbody>
                                <tr
                                  v-if="notification.obj.avaliacaoNota==null"
                                  style="padding:0;"
                                >
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                        border-collapse: collapse; padding: 0px;
                                        line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=5&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="1"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=4&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="2"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=3&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="3"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    ><span style="color:#FFCC00;">★
                                    </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=2&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="4"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    ><span style="color:#FFCC00;">★
                                    </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                          border-collapse: collapse; padding: 0px;
                                          line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=1&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                </tr>
                                <tr
                                  v-else
                                >
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                        border-collapse: collapse; padding: 0px;
                                        line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                          border-collapse: collapse; padding: 0px;
                                          line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <br>
                        <br>
                        <br>
                      </template>

                      <v-card>
                        <v-card-title
                          class="headline grey lighten-2"
                          primary-title
                          style="background-color: rgb(252, 227, 0);height: 65px;"
                        >
                          <v-list-item style="height:65px">
                            <v-list-item-content>
                              <v-list-item-title>
                                <div
                                  class="primary-text"
                                  style="height: 64px; background-color:
                                  rgb(252, 227, 0);height:65px"
                                >
                                  <center>
                                    <b>
                                      <font size="5">
                                        DETALHES SOBRE O ATENDIMENTO
                                      </font>
                                    </b>
                                    <v-btn
                                      style="margin-left: 50px;"
                                      text
                                    >
                                      X
                                    </v-btn>
                                  </center>
                                </div>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card-title>

                        <v-card-text>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                <center
                                  v-if="notification.obj.fotoAitLnk !== ''
                                    && notification.obj.fotoAitLnk !== null"
                                >
                                  <div style="color:#1e398d">
                                    AGENTE DE SEGURANÇA
                                  </div>
                                  <br>
                                  <center>
                                    <img
                                      data-v-22ba47ca=""
                                      style="width:120px;height:100px;"
                                      :src="notification.obj.fotoAitLnk"
                                      class="odash-dg-img"
                                    >
                                  </center>
                                  <center>
                                    <div style="color:#1e398d">
                                      {{ notification.obj.atendidoPor }}
                                    </div>
                                    <br>
                                  </center>
                                </center>
                                <span
                                  v-else
                                  style="font-size:10px;text-transform:
                                  uppercase;letter-spacing:.5px;"
                                >
                                  ''
                                </span>
                                <center
                                  v-if="notification.obj.fotoLocalLnk != ''
                                    && notification.obj.fotoLocalLnk != null"
                                >
                                  Foto do Local: <br>
                                  <br>
                                  <img
                                    data-v-22ba47ca=""
                                    :src="notification.obj.fotoLocalLnk"
                                    class="odash-dg-img"
                                    style="width:200px;"
                                  >
                                </center>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.resultado !=''"
                              >
                                Descrição: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.resultado }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary">
                                mdi-account
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                <center>
                                  <div style="color:#1e398d">
                                    {{ notification.obj.local }}
                                  </div>
                                </center>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.dataAtendimento !=''"
                              >
                                Data Atendimento: <br><b style="color:#1e398d"><br>{{ notification.
                                  obj.dataAtendimento }} às {{ notification.
                                  obj.horaAtendimento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.evento !=''"
                              >
                                Evento: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.evento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.resultadoDoAtendimento !=''"
                              >
                                Resultado do Atendimento: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.resultadoDoAtendimento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <b
                               v-if="notification.obj.observacao != ''"
                              >
                                Observações:
                              </b>
                              <div
                                style="color:#1e398d"
                              >
                                {{ notification.obj.observacao }}
                              </div>
                              <center
                                v-if="notification.obj.lnkImg.length>=1"
                              >
                              <br>
                              Fotos Tiradas no Local:<div
                                style="color:#1e398d"
                              >
                                <img
                                    v-for="img in notification.obj.lnkImg"
                                    :key="img"
                                    data-v-22ba47ca=""
                                    :src="img.lnkImg"
                                    class="odash-dg-img"
                                    style="width:200px;"
                                  >
                              </div>
                              </center>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </center>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </OrsCard>
      </v-col>
    </v-row>
    <v-row
      v-else-if="title!='Verificação de imagens'"
    >
      <v-col
        v-for="(notification, alarmIdx) in notifications"
        :key="alarmIdx"
        xs="12"
        sm="6"
        md="4"
        class="col-sm-6 col-md-6 col"
      >
        <OrsCard
          :title="notification.obj.tipoDeRat"
          :image="'https://orsegupsid.s3-sa-east-1.amazonaws.com/motocicle.png'"
        >
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-map-marker
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-capitalize">
                  {{ notification.obj.informativo }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">
                  mdi-account
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ notification.obj.local }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  v-if="notification.obj.dataAtendimento !=''"
                >
                  <b> Data Atendimento: </b>{{ notification.
                    obj.dataAtendimento }} às {{ notification.
                    obj.horaAtendimento }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                 v-if="notification.obj.evento !=''"
                >
                  EVENTO: {{ notification.obj.evento }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                 v-if="notification.obj.fotoLocalLnk != ''
                    && notification.obj.fotoLocalLnk != null"
                >
                  <center>
                    Foto do Local: <br>
                    <br>
                    <img
                      data-v-22ba47ca=""
                      :src="notification.obj.fotoLocalLnk"
                      class="odash-dg-img"
                      style="width:200px;"
                    >
                  </center>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <center>
                    <v-dialog
                      width="800"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          dark
                          v-on="on"
                        >
                          Ver Detalhes
                        </v-btn>
                        <div
                          style="color: rgb(180, 186, 194) !important;
                          font-family: sans-serif, serif,
                          EmojiFont; text-align: center;"
                          data-ogsc="rgb(96, 102, 109)"
                        >
                          <span
                            v-if="notification.obj.avaliacaoNota==null"
                            style="font-size:10px;text-transform:
                            uppercase;letter-spacing:.5px;"
                          >Avalie este atendimento
                          </span>
                          <span
                            v-else
                            style="font-size:10px;text-transform:
                            uppercase;letter-spacing:.5px;"
                          >AVALIAÇÂO JÁ EFETUADA.
                          </span>
                          <br>
                          <div
                            style="unicode-bidi:bidi-override;
                            direction:rtl;width:100%;
                            float:left;"
                          >
                            <table
                              style="color: rgb(175, 175, 175) !important;
                              font-size: 35px;; font-family: Helvetica, Arial,
                              sans-serif; width: 275px; border-collapse: collapse;
                              margin: 10px auto;"
                              data-ogsc="rgb(120, 120, 120)"
                            >
                              <tbody>
                                <tr
                                  v-if="notification.obj.avaliacaoNota==null"
                                  style="padding:0;"
                                >
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                        border-collapse: collapse; padding: 0px;
                                        line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=5&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="1"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=4&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="2"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=3&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="3"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    ><span style="color:#FFCC00;">★
                                    </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=2&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="4"
                                      style="color:#00A9E0;
                                      text-decoration:none;
                                      padding:2px 0;"
                                    ><span style="color:#FFCC00;">★
                                    </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                          border-collapse: collapse; padding: 0px;
                                          line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      :href="'https://www.orsegups.com.br/rat/avaliacao?rating=1&amp;ratingToken='+notification.obj.ratingToken"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span style="color:#FFCC00;">★
                                      </span></a>
                                  </td>
                                </tr>
                                <tr
                                  v-else
                                >
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                        border-collapse: collapse; padding: 0px;
                                        line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                    border-collapse: collapse; padding: 0px;
                                    line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                  <td
                                    width="55"
                                    style="color: rgb(175, 175, 175) !important;
                                          border-collapse: collapse; padding: 0px;
                                          line-height: 24px;"
                                    data-ogsc="rgb(120, 120, 120)"
                                  >
                                    <a
                                      target="#"
                                      rel="noopener noreferrer"
                                      data-auth="NotApplicable"
                                      disable="true"
                                      width="55"
                                      tabindex="5"
                                      style="color:#00A9E0;text-decoration:none;padding:2px 0;"
                                    >
                                      <span
                                        style="color:##d8dbf6;text-decoration: none;
                                        cursor: not-allowed; opacity: 0.2; pointer-events: none;"
                                      >★
                                      </span></a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <br>
                        <br>
                        <br>
                      </template>

                      <v-card>
                        <v-card-title
                          class="headline grey lighten-2"
                          primary-title
                          style="background-color: rgb(252, 227, 0);height: 65px;"
                        >
                          <v-list-item style="height:65px">
                            <v-list-item-content>
                              <v-list-item-title>
                                <div
                                  class="primary-text"
                                  style="height: 64px; background-color:
                                  rgb(252, 227, 0);height:65px"
                                >
                                  <center>
                                    <b>
                                      <font size="5">
                                        DETALHES SOBRE O ATENDIMENTO
                                      </font>
                                    </b>
                                    <v-btn
                                      style="margin-left: 50px;"
                                      text
                                    >
                                      X
                                    </v-btn>
                                  </center>
                                </div>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card-title>

                        <v-card-text>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                <center
                                  v-if="notification.obj.fotoAitLnk !== ''
                                    && notification.obj.fotoAitLnk !== null"
                                >
                                  <div style="color:#1e398d">
                                    AGENTE DE SEGURANÇA
                                  </div>
                                  <br>
                                  <center>
                                    <img
                                      data-v-22ba47ca=""
                                      style="width:120px;height:100px;"
                                      :src="notification.obj.fotoAitLnk"
                                      class="odash-dg-img"
                                    >
                                  </center>
                                  <center>
                                    <div style="color:#1e398d">
                                      {{ notification.obj.atendidoPor }}
                                    </div>
                                    <br>
                                  </center>
                                </center>
                                <span
                                  v-else
                                  style="font-size:10px;text-transform:
                                  uppercase;letter-spacing:.5px;"
                                >
                                  ''
                                </span>
                                <center
                                  v-if="notification.obj.fotoLocalLnk != ''
                                    && notification.obj.fotoLocalLnk != null"
                                >
                                  Foto do Local: <br>
                                  <br>
                                  <img
                                    data-v-22ba47ca=""
                                    :src="notification.obj.fotoLocalLnk"
                                    class="odash-dg-img"
                                    style="width:200px;"
                                  >
                                </center>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.resultado !=''"
                              >
                                Descrição: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.resultado }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary">
                                mdi-account
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>
                                <center>
                                  <div style="color:#1e398d">
                                    {{ notification.obj.local }}
                                  </div>
                                </center>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.dataAtendimento !=''"
                              >
                                Data Atendimento: <br><b style="color:#1e398d"><br>{{ notification.
                                  obj.dataAtendimento }} às {{ notification.
                                  obj.horaAtendimento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.evento !=''"
                              >
                                Evento: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.evento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                           <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-if="notification.obj.resultadoDoAtendimento !=''"
                              >
                                Resultado do Atendimento: <br><b
                                  style="color:#1e398d"
                                ><br>{{ notification.obj.resultadoDoAtendimento }}</b>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="primary" />
                            </v-list-item-icon>
                            <v-list-item-content>
                              <b
                               v-if="notification.obj.observacao != ''"
                              >
                                Observações:
                              </b>
                              <div
                                style="color:#1e398d"
                              >
                                {{ notification.obj.observacao }}
                              </div>
                              <center
                                v-if="notification.obj.lnkImg.size>=1"
                              >
                                <br>
                                Fotos Tiradas no Local:<div
                                  style="color:#1e398d"
                                >
                                  <img
                                    data-v-22ba47ca=""
                                    :src="notification.obj.lnkImg[1].lnkImg"
                                    class="odash-dg-img"
                                    style="width:200px;"
                                  >
                                </div>
                              </center>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </center>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </OrsCard>
        Verificação de imagens
      </v-col>
    </v-row>
    <v-row
      v-else
      justify="center"
      class="mt-8"
    >
      <h3>
        Nenhuma Notificação para exibir
      </h3>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import OrsInnerToolbar from '@/components/OrsInnerToolbar.vue';
import OrsCard from '@/components/OrsCard.vue';

const notificationList = createNamespacedHelpers('views/notifications');
const session = createNamespacedHelpers('session');

export default {
  name: 'Notifications',
  components: {
    OrsInnerToolbar,
    OrsCard,
  },
  computed: {
    ...notificationList.mapGetters([
      'isLoading',
      'noResults',
    ]),
    ...notificationList.mapState([
      'notifications',
      'status',
    ]),
    isContainerEnabled() {
      const map = {
        NotificationList: true,
      };
      return map[this.$route.name];
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.loadNotifications();
      vm.addAccountChangeListener(vm.loadNotifications);
    });
  },
  beforeRouteLeave(to, from, next) {
    this.removeAccountChangeListener(this.loadNotifications);
    next();
  },
  methods: {
    ...session.mapMutations([
      'addAccountChangeListener',
      'removeAccountChangeListener',
    ]),
    ...notificationList.mapActions([
      'loadNotifications',
    ]),
    checkImgOnline(imageUrl){
      var img = new Image();
      img.src = imageUrl;
      if(img.height>0){
        true;
      } else {
        false;
      }
    },
  },
};
</script>
